import { useParams } from 'react-router'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { useFetchInvoice } from '@features/invoices/hooks/useFetchInvoice'

import { InvoiceEditorUrlParams } from '../../../types/invoiceEditorUrlParams'
import { useInvoiceEditorDocumentType } from './useInvoiceEditorDocumentType'

export const useCreditNoteSourceInvoice = () => {
  const { documentId } = useParams<InvoiceEditorUrlParams>()
  const { isCreditNote } = useInvoiceEditorDocumentType()

  const { invoice } = useFetchInvoice(InvoiceDocumentType.Invoice, isCreditNote ? documentId : undefined)

  return isCreditNote ? invoice : undefined
}
